import { render, staticRenderFns } from "./MatchProgress.vue?vue&type=template&id=34043bb4&scoped=true&"
import script from "./MatchProgress.vue?vue&type=script&lang=js&"
export * from "./MatchProgress.vue?vue&type=script&lang=js&"
import style0 from "./MatchProgress.vue?vue&type=style&index=0&id=34043bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34043bb4",
  null
  
)

export default component.exports